import {Component, OnInit} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {SearchHelpers} from "../../helpers/search-helper";

export interface ImportK2GroupsInputModel {
  k2Groups: any[];
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./import-k2-groups-dialog.template.pug",
  providers: [
  ],
})
export class ImportK2GroupsDialogComponent extends DialogComponent<ImportK2GroupsInputModel, any[]>
  implements ImportK2GroupsInputModel, OnInit {
  projectId: string;
  error: Error;
  orderName: string;
  k2Groups: any[] = [];
  selectedCount: number = 0;
  k2GroupsFiltered: any[] = [];
  k2GroupsToShow: any[] = [];

  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number = 1;
  searchText: string = "";

  static showImportK2GroupsDialogModal(
    dialogService: DialogService,
    input: ImportK2GroupsInputModel,
  ): Promise<any[]> {
    return dialogService.showDialog(ImportK2GroupsDialogComponent, input, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  cancel(): void {
    this.result = [];
    this.close();
  }

  importGroups() {
    this.result = this.k2Groups.filter(it => it.selected);
    this.close();
  }

  public deselectAll(): void {
    this.k2Groups.forEach((areaGroup) => { areaGroup.selected = false; });
    this.selectedCount = 0;
  }

  public selectAll(): void {
    this.k2Groups.forEach((areaGroup) => { areaGroup.selected = true; });
    this.selectedCount = this.k2Groups.length;
  }

  ngOnInit(): void {
    this.k2Groups.forEach((areaGroup, index) => { areaGroup.index = index; });
    this.deselectAll();
    this.loadFilteredGroups();
  }

  public updateSelection(index): void {
    if (index < 0 || index >= this.k2Groups.length) return;
    if (this.k2Groups[index].selected === true) {
      this.selectedCount += 1;
    } else {
      this.selectedCount -= 1;
    }
  }

  private loadFilteredGroups(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.k2GroupsFiltered = this.k2Groups.filter((g) => {
      if (this.searchText) {
        const values = [
          g.areaName,
          g.groupName,
        ].filter(it => !!it);

        const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
          .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;

        if (searchFailures) return false;
      }

      return true;
    });
    // Filter the Filtered Groups to get the Groups to Show
    this.k2GroupsToShow = this.k2GroupsFiltered.slice(start, end);
    // Update the number of Max Pages
    this.maxPages = Math.ceil(this.k2GroupsFiltered.length / (+this.pageSize));
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        break;
    }

    this.loadFilteredGroups();
  }
}
